import { Text } from '@mantine/core';
import { IconHandClick, IconSquarePlus } from '@tabler/icons-react';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import {
	EmptyStateIconTile,
	EmptyStateRemainingPill,
	EmptyStateWrapper,
} from './bindPanel.styled.ts';
import type { BindPanelEmptyVariant } from './BindPanel.types.ts';

interface Props {
	variant: BindPanelEmptyVariant;
	unboundCount: number;
}

/**
 * Stands in for {@link BindPanel} when no field is selected, so the side column
 * always says what to do next instead of going blank.
 */
export const BindPanelEmptyState = ({ variant, unboundCount }: Props) => {
	const tMipManage = useTranslationMipManage();
	const hasNoFields = variant === 'no-fields';

	return (
		<EmptyStateWrapper data-testid="bind-panel-empty-state">
			<EmptyStateIconTile $variant={hasNoFields ? 'dashed' : 'solid'}>
				{hasNoFields ? <IconSquarePlus size={28} /> : <IconHandClick size={28} />}
			</EmptyStateIconTile>
			<Text fw={600}>
				{tMipManage(
					hasNoFields
						? 'master_documents.field_binding.empty.no_fields.title'
						: 'master_documents.field_binding.empty.none_selected.title'
				)}
			</Text>
			<Text size="sm" c="dark.0">
				{tMipManage(
					hasNoFields
						? 'master_documents.field_binding.empty.no_fields.body'
						: 'master_documents.field_binding.empty.none_selected.body'
				)}
			</Text>
			{!hasNoFields && unboundCount > 0 && (
				<EmptyStateRemainingPill>
					<Text size="xs" c="blue.7">
						{tMipManage(
							unboundCount === 1
								? 'master_documents.field_binding.empty.none_selected.remaining_one'
								: 'master_documents.field_binding.empty.none_selected.remaining_other',
							{ count: unboundCount }
						)}
					</Text>
				</EmptyStateRemainingPill>
			)}
		</EmptyStateWrapper>
	);
};
